module.exports = __webpack_public_path__ + "img/pp1.2ebb7600.png";